import {TAcquisitionPropertyRecord} from "../components/acquisition-property-form/AcquisitionPropertyForm";

export type TFormError = {
    field: string;
    message: string;
}

export default class AcquisitionPropertyValidator {
    validate(property: TAcquisitionPropertyRecord): TFormError[] {
        const errors: TFormError[] = [];

        if (!property.name || property.name.trim() === '') {
            errors.push({
                field: 'name',
                message: 'Name is required'
            });
        }

        if (property.acquisitionBudgetYear === undefined || property.acquisitionBudgetYear === null) {
            errors.push({
                field: 'acquisitionBudgetYear',
                message: 'Acquisition Budget Year is required'
            });
        } else if (isNaN(Number(property.acquisitionBudgetYear))) {
            errors.push({
                field: 'acquisitionBudgetYear',
                message: 'Acquisition Budget Year must be a number'
            });
        }

        if (property.acquisitionBudgetStartMonth === undefined || property.acquisitionBudgetStartMonth === null) {
            errors.push({
                field: 'acquisitionBudgetStartMonth',
                message: 'Acquisition Budget Start Month is required'
            });
        } else if (isNaN(Number(property.acquisitionBudgetStartMonth)) ||
                  Number(property.acquisitionBudgetStartMonth) < 0 ||
                  Number(property.acquisitionBudgetStartMonth) > 11) {
            errors.push({
                field: 'acquisitionBudgetStartMonth',
                message: 'Acquisition Budget Start Month must be a number between 0 and 11'
            });
        }

        if (!property.acquisitionBudgetPeriod) {
            errors.push({
                field: 'acquisitionBudgetPeriod',
                message: 'Acquisition Budget Period is required'
            });
        }

        if(!property.revenueConfiguration) {
            errors.push({
                field: 'revenueConfiguration',
                message: 'Revenue Configuration is required'
            });
        }

        return errors;
    }
}